var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"a",attrs:{"d":"M-1211.344,236.656l7.114,7.155-7.114,6.907","transform":"translate(1212.758 -235.242)"}})}
var staticRenderFns = []

export { render, staticRenderFns }